// extracted by mini-css-extract-plugin
export default {"partner-rufa-logo":"PartnerRufaLogo_partner-rufa-logo__VFd1z"};